import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { taxDetails } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the tax-detail resource
export const [actions, reducer, resourceSagas] = resourceReducer('tax-details');

// Create the sagas for this entity
function* readTaxDetails() {
  yield takeEvery(actions.indexRequestBegin, function*({ payload }) {
    const { args } = payload;
    try {
      const result = yield call(taxDetails.get, args);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess({ ...normalized, args }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error, args }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readTaxDetails, ...resourceSagas];
